import BaseApi from './base-api';

export default class ReportParamsApi extends BaseApi {
  loadParams(dto) {
    return this.authorizedFetch('/api/v1/parameters', {
      method: 'PUT',
      body: JSON.stringify(dto),
    });
  }
}
